"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Filter = _interopRequireDefault(require("./Filter"));

var _widgetContainer = _interopRequireWildcard(require("@insided/deprecated-preact-components/widget-container"));

var _shared = require("../../Navigation/shared");

var _zod = require("zod");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'content_category_filter';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-content_category_filter';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  config: _zod.z.any(),
  title: _zod.z.string(),
  categoriesV2: _zod.z.array(_zod.z.object({
    id: _zod.z.number(),
    title: _zod.z.string(),
    description: _zod.z.string().nullable(),
    heroImage: _zod.z.string().nullable(),
    thumbnailImage: _zod.z.string().nullable(),
    parentId: _zod.z.number().nullable(),
    type: _zod.z.number().optional(),
    isContainer: _zod.z.boolean(),
    metaRobots: _zod.z.enum(['index, follow', 'noindex, follow', 'index, nofollow', 'noindex, nofollow']),
    seoTitle: _zod.z.string().nullable(),
    seoDescription: _zod.z.string().nullable(),
    hideFromSearch: _zod.z.boolean(),
    includeForStats: _zod.z.boolean(),
    displayOrder: _zod.z.string(),
    children: _zod.z.array(_zod.z.any()),
    topicsOrder: _zod.z.array(_zod.z.number()),
    isCollapsed: _zod.z.boolean(),
    visibleTopicsCount: _zod.z.number(),
    curatedContent: _zod.z.string().optional(),
    curatedContentTitle: _zod.z.string().optional(),
    url: _zod.z.string(),
    language: _zod.z.string().optional()
  }))
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var WidgetContentCategoryFilter = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(WidgetContentCategoryFilter, _Component);

  var _super = _createSuper(WidgetContentCategoryFilter);

  function WidgetContentCategoryFilter() {
    (0, _classCallCheck2.default)(this, WidgetContentCategoryFilter);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(WidgetContentCategoryFilter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          categoriesV2 = _this$props.categoriesV2,
          title = _this$props.title;
      return (0, _preact.h)(_widgetContainer.default, {
        widgetName: widgetName,
        config: {
          title: title
        },
        boundedContext: "Content",
        entity: "CategoryFilter"
      }, (0, _preact.h)(_Filter.default, {
        categories: categoriesV2,
        onCategorySelect: WidgetContentCategoryFilter.onCategorySelect
      }));
    }
  }]);
  return WidgetContentCategoryFilter;
}(_preact.Component);

(0, _defineProperty2.default)(WidgetContentCategoryFilter, "onCategorySelect", function (category) {
  (0, _shared.updateQueryFilters)({
    category: category
  });
});
var _default = WidgetContentCategoryFilter;
exports.default = _default;